import { createClient, CreateClientParams } from "contentful";
import { ContentfulClientInterface } from "../contexts/contentful/ContentfulContext";

export const ContentfulClient = (
  params: CreateClientParams,
): ContentfulClientInterface => {
  return createClient(params);
};
